import Repository from './repository'

const resource = '/paramvenda'

export default {

  getId (id) {
    return Repository.get(`${resource}/${id}`)
  },
  getList (uf, cidade) {
    return Repository.get(`${resource}/${uf}/${cidade}`)
  },
  Update (data) {
    return Repository.post(`${resource}/editar/`, data)
  },
  Delete (data) {
    return Repository.post(`${resource}/excluir/`, data)
  },
  Save (data) {
    return Repository.post(`${resource}/save/`, data)
  },
}
